import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { APP_ROUTES } from '../../globals/constants';

import './ErrorPage.scss';

const ErrorPage = () => {
	const navigate = useNavigate();
	useEffect(() => {
		navigate(APP_ROUTES.ROUTE_LOGIN, {});
	}, []);
	return (
		<div className="ErrorPage d-flex flex-column justify-content-center w-100 h-100 container">
			<div className="ErrorPage__header mb-3">Oops!</div>
			<div className="ErrorPage__title mb-3">Something went wrong here.</div>

			{/* <div className="ErrorPage__info1 mb-2">{`We're working on it and we'll get it fixed as soon possible.`}</div>

      <div className="ErrorPage__info2">
        You can <Link to={APP_ROUTES.ROUTE_ROOT}>go back</Link> or raise an
        issue on{" "}
        <a href="mailto:support@mail-acc.com" target="_blank" rel="noreferrer">
          support@mail-acc.com
        </a> */}
			{/* . */}
			{/* </div> */}
		</div>
	);
};

export default ErrorPage;
